/**
 * Builds a filterFields function
 * @param func This function decides which fields to keep.<br/>
 *  For example, if<br/>
 *  <code>obj = { a: 0, b: 1, c: 4 }</code><br/>
 *  and we need to filter all fields whose value is lower than 1, then func could be written as<br/>
 *  <code>x => x >= 1</code>
 * @returns {function(*=): {}}
 */
export const buildFilterFields = (func) => (obj) =>
  Object.entries(obj).reduce((obj, [field, value]) => {
    if (func(value)) obj[field] = value
    return obj
  }, {})

  export const deleteEmptyProps = (obj) => {
    if (Array.isArray(obj)) {
      return obj
        .map(deleteEmptyProps) // Recursively clean array items
        .filter((item) => item !== undefined) // Remove fully empty items
    }
  
    if (typeof obj === 'object' && obj !== null) {
      const output = {}
      for (const [key, value] of Object.entries(obj)) {
        const cleaned = deleteEmptyProps(value)
        // Keep value if it's truthy or is false/0 (but skip null, undefined, '')
        if (
          cleaned !== undefined &&
          cleaned !== null &&
          cleaned !== '' &&
          (typeof cleaned === 'object' ? Object.keys(cleaned).length > 0 : true)
        ) {
          output[key] = cleaned
        }
      }
      return Object.keys(output).length ? output : undefined
    }
  
    return obj
  }
